export default "__VITE_ASSET__CPbAQd55__"